import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { Pill, aud } from "../ui";
import { H, TextBlock } from "./parts";

export function ClaimFacts({ p }) {
  const c = p.claim;
  const rows = [["Chassis", c.chassis], ["Customer", c.customer], ["Model", c.model], ["Dealer", c.dealer], ["Claim date", c.claim_date],
    ["Claimed", c.quoted_total != null ? aud(c.quoted_total, 2) : c.quoted_total_text], ["Submitted by", [c.submitted_by_name, c.submitted_by_email].filter(Boolean).join(" · ")],
    ["Photos", p.photo_count]];
  return (
    <div className="space-y-4" data-testid="wi-approve-claim-facts">
      <dl className="grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-3 text-xs">
        {rows.map(([k, v]) => <div key={k}><dt className="text-neutral-500">{k}</dt><dd className="text-neutral-200 break-words">{v || v === 0 ? v : "—"}</dd></div>)}
      </dl>
      <div className="grid md:grid-cols-2 gap-4">
        <TextBlock title="Warranty issue" text={c.warranty_issues} testId="wi-approve-issue" />
        <TextBlock title="Parts required (from the claim)" text={c.parts_required} testId="wi-approve-parts-text" />
      </div>
    </div>
  );
}

export function Blockers({ items }) {
  if (!items?.length) return null;
  return (
    <div className="border border-red-500/40 bg-red-500/[0.06] rounded-xl p-4" data-testid="wi-approve-blockers">
      <H>Can't approve here</H>
      <ul className="text-sm text-red-300 space-y-1">{items.map((b) => <li key={b}>{b}</li>)}</ul>
    </div>
  );
}

export function Duplicates({ items, checked, onChange, blocked }) {
  if (!items?.length) return null;
  return (
    <div className="border border-amber-500/40 bg-amber-500/[0.06] rounded-xl p-4 space-y-3" data-testid="wi-approve-duplicates">
      <H>Possible duplicate claims on this caravan</H>
      <ul className="text-xs space-y-2">
        {items.map((d) => (
          <li key={d.claim_id} className="text-neutral-300">
            <span className="font-mono text-neutral-100">{d.otma || "No OTMA"}</span> · {d.claim_date} · {d.status || "—"} {d.likely && <Pill tone="amber">{d.reason}</Pill>}
            <div className="text-neutral-500">{d.issue}</div>
          </li>
        ))}
      </ul>
      {!blocked && (
        <label className="flex items-center gap-2 text-sm text-amber-200 cursor-pointer">
          <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} data-testid="wi-approve-confirm-dup" /> I've checked these, and this claim isn't a duplicate
        </label>
      )}
    </div>
  );
}
